module.exports = __webpack_public_path__ + "d3ec5a816e02d3c6d54d4bba44f3ac05.svg";